<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div style="margin-right: 28px;">
				<CommonBtngroup ref="QuotaBtngroup" :qhide="false"
					:chackbox="userInfo && userInfo.IsSaler === 1?false:true" checktitle="待我审批" @showclick="showclick"
					@hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				<div style="color:red;padding: 50px 30px;" v-if="markupRateText">{{markupRateText}}</div>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<el-dropdown @command="handApply">
					<Commonbtn v-if="qx.add||qx.update" margin="8px" backgroundColor="#FFF" title="指标申请"
						fontSize="14px" />
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-if="qx.add" command="add" icon="el-icon-circle-plus">新增</el-dropdown-item>
						<el-dropdown-item v-if="qx.update" command="edit"
							icon="el-icon-edit-outline">编辑</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div style="display: inline-block;">
				<el-dropdown @command="handTrans">
					<Commonbtn v-if="qx.add||qx.update" margin="8px" backgroundColor="#FFF" title="指标平移"
						fontSize="14px" />
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-if="qx.add" command="add" icon="el-icon-circle-plus">新增</el-dropdown-item>
						<el-dropdown-item v-if="qx.update" command="edit"
							icon="el-icon-edit-outline">编辑</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div style="display: inline-block;">
				<!--  -->
				<Commonbtn v-if="qx.del" margin="8px" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn margin="8px" backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="AppExport"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.submit" margin="8px" backgroundColor="#FFF" title="提交" fontSize="14px"
					@btnclick="Submit" opwidth="70px" top="353px" :src="require('@/assets/channel/Submit.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.submit" margin="8px" backgroundColor="#FFF" title="撤回" fontSize="14px"
					@btnclick="withdraw" :src="require('@/assets/channel/withdraw.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval&&userInfo && userInfo.IsSaler === 1?false:true" margin="8px"
					backgroundColor="#FFF" title="审批通过" fontSize="14px" @btnclick="Approved"
					:src="require('@/assets/channel/Approved.png')">
				</Commonbtn>
			</div>
			<!--  -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval&&userInfo && userInfo.IsSaler === 1?false:true" backgroundColor="#FFF"
					title="驳回" margin="8px" fontSize="14px" @btnclick="Rejectapproval"
					:src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn margin="8px" backgroundColor="#FFF" title="审批流程" fontSize="14px" @btnclick="Approvalprocess"
					:src="require('@/assets/channel/Approvalprocess.png')">
				</Commonbtn>
			</div>

			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" margin="8px"
				backgroundColor="#FFF" title="月度导入" fontSize="14px" @getFile="ImportMonthData" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a style="margin-right:30px;" class="Dowload" @click="downloadMonthTemplet">月度导入模板下载</a>
			<CommonbtnUpLoad v-if="qx.add&&[1,2,3].includes(new Date().getMonth() + 1)"
				style="display: inline-block;margin-top: 10px;" margin="8px" backgroundColor="#FFF" title="年度导入"
				fontSize="14px" @getFile="ImportYearData" types="file" :src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a style="" class="Dowload" v-if="[1,2,3].includes(new Date().getMonth() + 1)"
				@click="downloadYearTemplet">年度导入模板下载</a>

			<div class="Table">
				<Commontable ref="refTableQuota" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
					width="1000px" colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange"
						@handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
				</div>
				<div v-show="tableDataTow.length > 0">
					<div class="TableTitle">
						指标
					</div>
					<Commontable ref="refTableQuota" @onRowClick="onRowClickTow" width="1000px" colnum=7
						:tableData="tableDataTow" :headerData="headerDataTow" height="100%">
					</Commontable>
				</div>
			</div>

		</div>
		<DialogFrom width="1000px" :title="TitleEditor" :OKASCAN="true" :dialogVisible="dialogVisibAuthorizationsAdd"
			@cancel="cancelAuthorizationsAdd" @dialogOK="dialogOKAuthorizationsAdd">
			<FromComm :FromArr="FromArrEditor" @FourthQuarterChange="FourthQuarterChange"
				@ThirdQuarterChange="ThirdQuarterChange" @FirstQuarterChange="FirstQuarterChange"
				@QuarterChange="QuarterChange" @SecondQuarterChange="SecondQuarterChange" @YearChange="YearChange"
				@OnceYearChange="OnceYearChange" @YearQuotaChange="YearQuotaChange"
				@AuthorizedDealerChange="AuthorizedDealerChange" @AuthorizedTransChange="AuthorizedTransChange"
				@invClassChange="invClassChange" @level15Change="level15Change" @remoteMethod="remoteMethod"></FromComm>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="dialogVisibRejectapproval"
			@cancel="cancelRejectapproval" @dialogOK="dialogOKRejectapproval">
			<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
			</el-input>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="审批流程" :dialogVisible="dialogVisiblesApprovalprocess"
			@cancel="cancelApprovalprocess" @dialogOK="dialogOKApprovalprocess">
			<div class="from">
				<Commontable ref="refTableQuota" width="1000px" colnum=7 :loadingTable="loadingTableprocess"
					:tableData="ApprovalProcessTableData" :headerData="ApprovalProcessHeaderData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleApproved" @cancel="cancelApproved"
			@dialogOK="dialogOKApproved" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审批通过这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblewithdraw" @cancel="cancelwithdraw"
			@dialogOK="dialogOKwithdraw" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要撤回这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleSubmit" @cancel="cancelSubmit"
			@dialogOK="dialogOKSubmit" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要提交这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该数据吗？</span>
		</Dialog>
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import FromArr from './FromData/FromArr'
	import headerData from './headerData/headerData'
	import headerDataTow from './headerData/headerDataTow2'
	import headerDataEditor from './headerData/headerDataEditor'
	import ApprovalProcessHeaderData from './headerData/ApprovalProcessHeaderData'
	import FromArrEditor from './FromData/FromArrEditor'
	import FromArrTrans from './FromData/FromArrTrans'
	import utils from '../../../../../../common/utils'
	import {
		APPCustomerQuotaList,
		APPCustomerQuotaAdd,
		APPCustomerQuotaInfo,
		APPCustomerQuotaEdit,
		APPCustomerQuotaDelete,
		APPCustomerQuotaSubmit,
		APPCustomerQuotaReject,
		APPCustomerQuotaRevoke,
		APPCustomerQuotaApprove,
		APPCustomerQuotaGetHostory,
		APPCustomerQuotaExport,
		HelperApprovalFlowStatus,
		QuotaDefaultRatioInfo,
		APPCustomerQuotaGetAPPCustomerQuotaForAddNew,
		HelperLEVEL1_5,
		DownloadAPPCustomerQuota,
		ImportAPPCustomerQuota,
		ImportYearAPPCustomerQuota,
		DownloadYearQuotaTempletQuota
	} from '@/api/channel'
	import {
		InventoryClassList,
		CustomerList
	} from '@/api/home'
	import {
		GetMarkupRateInfo,
		ShareQuarterToMonth
	} from '@/api/newsapi'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			Dialog
		},
		props: {},
		data() {
			return {
				dialogVisibAuthorizationsAdd: false,
				dialogVisibAuthorizationsAddHP: false,
				dialogVisiblesApprovalprocess: false,
				dialogVisibleApproved: false,
				dialogVisiblewithdraw: false,
				dialogVisibRejectapproval: false,
				dialogVisibleSubmit: false,
				dialogVisiblesdrjg: false,
				dialogVisibleVerify: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				chackbox: true,
				loadingTableprocess: true,
				RejectReason: '',
				InvClass: '',
				invClassRow: '',
				title: '',
				TitleEditor: '',
				ProviderID: '',
				ProviderName: '',
				CusCode: '',
				CusName: '',
				BAMID: null,
				ApprovalProcessHeaderData: [],
				ApprovalProcessTableData: [],
				IDs: [],
				qus: [],
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				headerDataEditor: [],
				tableDatadrjg: [],
				DataListOK: [],
				FromArr: [],
				FromArrEditor: [],
				headerData: [],
				headerDataTow: [],
				tableDataTow: [],
				tableData: [],
				from: {
					ApplyCode: '',
					CusName: '',
					InvClass: '',
					Status: '',
					CreateTime1: '',
					CreateTime2: '',
					MyApproval: 1,
					Year: ''
				},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
				},
				currYear: new Date().getFullYear(),
				currMonth: new Date().getMonth() + 1,
				markupRateText: ''
			}
		},
		created() {
			if (this.userInfo && this.userInfo.IsSaler === 1) {
				this.from.MyApproval = '';
			}
			this.APPCustomerQuotaList()
			this.inventoryClassList()
			this.HelperApprovalFlowStatus()
			this.getRateInfo();
		},

		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			},
			// 获取去年-今年-明年
			Year() {
				let date = new Date()
				let yearStr = `${date.getFullYear() - 1}-${date.getFullYear()}-${date.getFullYear() + 1}`
				let yearArr = [{
						key: date.getFullYear() - 1,
						value: `${date.getFullYear() - 1}年`,
					},
					{
						key: date.getFullYear(),
						value: `${date.getFullYear()}年`,
					},
					{
						key: date.getFullYear() + 1,
						value: `${date.getFullYear() + 1}年`,
					},
				]
				return yearArr
			},
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = FromArrEditor
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			this.ApprovalProcessHeaderData = JSON.parse(JSON.stringify(ApprovalProcessHeaderData))
			this.FromArrEditor[0].options = this.Year
			this.FromArr[2].options = this.Year
			this.$refs.QuotaBtngroup.checkeds = true
		},
		activated() {},
		updated() {},
		methods: {
			//指标申请
			handApply(e) {
				if (e == 'add') {
					this.TitleEditor = '新增指标申请'
					this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
					this.FromArrEditor[0].options = this.Year
					this.dialogVisibAuthorizationsAdd = true
					this.inventoryClassList()
				}
				if (e == 'edit') {
					if (!this.ID) {
						this.$message.warning('请选中一行数据！');
						return;
					}
					this.TitleEditor = '修改指标申请'
					this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
					this.FromArrEditor[0].options = this.Year
					this.APPCustomerQuotaInfo("Edit")
					this.inventoryClassList()
				}
			},
			//指标平移
			handTrans(e) {
				if (e == 'add') {
					console.log(111);
					this.TitleEditor = '新增指标平移'
					this.FromArrEditor = JSON.parse(JSON.stringify(FromArrTrans))
					this.FromArrEditor[0].options = this.Year
					this.dialogVisibAuthorizationsAdd = true
					this.inventoryClassList()
					console.log(this.FromArrEditor);
				}
				if (e == 'edit') {
					if (!this.ID) {
						this.$message.warning('请选中一行数据！');
						return;
					}
					this.TitleEditor = '修改指标平移'
					this.FromArrEditor = JSON.parse(JSON.stringify(FromArrTrans))
					this.FromArrEditor[0].options = this.Year
					this.APPCustomerQuotaInfo("Edit")
					this.inventoryClassList()
				}
				console.log(e, this.FromArrEditor.length);
			},
			//加价率文案查询
			async getRateInfo() {
				let {
					code,
					data
				} = await GetMarkupRateInfo({})
				if (code == 0) {
					this.markupRateText = data;
				}
			},
			//季度改变
			async QuarterChange(i) {
				let {
					code,
					message,
					data
				} = await ShareQuarterToMonth({
					Quota: this.FromArrEditor[i].modelValue
				})
				if (code == 0) {

					if (i === 6) {
						// 第一季度
						this.FromArrEditor[7].modelValue = data.FirstMonth;
						this.FromArrEditor[8].modelValue = data.SecondMonth;
						this.FromArrEditor[9].modelValue = data.ThirdMonth;
					}

					if (i === 10) {
						// 第二季度
						this.FromArrEditor[11].modelValue = data.FirstMonth;
						this.FromArrEditor[12].modelValue = data.SecondMonth;
						this.FromArrEditor[13].modelValue = data.ThirdMonth;
					}

					if (i === 14) {
						// 第三季度
						this.FromArrEditor[15].modelValue = data.FirstMonth;
						this.FromArrEditor[16].modelValue = data.SecondMonth;
						this.FromArrEditor[17].modelValue = data.ThirdMonth;
					}

					if (i === 18) {
						// 第四季度
						this.FromArrEditor[19].modelValue = data.FirstMonth;
						this.FromArrEditor[20].modelValue = data.SecondMonth;
						this.FromArrEditor[21].modelValue = data.ThirdMonth;
					}

					//计算 年度总指标集合
					let indexs = [7, 8, 9, 11, 12, 13, 15, 16, 17, 19, 20, 21];
					let Sum = 0
					this.FromArrEditor.forEach((item, index) => {
						if (indexs.includes(index)) {
							Sum = this.$utils.floatAdd(Sum, item.modelValue);

						}
					})
					this.FromArrEditor[5].modelValue = Sum;

				} else {
					this.$message.warning(message)
				}
			},
			OnceYearChange() {
				console.log('------>>', this.FromArrEditor[3].checked, this.FromArrEditor);
				if (this.FromArrEditor[3].checked) {
					this.FromArrEditor[5].disabled = false; //年度

					this.FromArrEditor[6].disabled = true;
					this.FromArrEditor[10].disabled = true;
					this.FromArrEditor[14].disabled = true;
					this.FromArrEditor[18].disabled = true;
				} else {
					this.FromArrEditor[5].disabled = true; //年度

					if (this.currYear == this.FromArrEditor[0].modelvalue) {
						//一季度
						if (this.currMonth >= 1 && this.currMonth <= 3) {
							this.FromArrEditor[6].disabled = false;
							this.FromArrEditor[10].disabled = false;
							this.FromArrEditor[14].disabled = false;
							this.FromArrEditor[18].disabled = false;
						}

						//二季度
						if (this.currMonth >= 4 && this.currMonth <= 6) {
							this.FromArrEditor[6].disabled = true;
							this.FromArrEditor[10].disabled = false;
							this.FromArrEditor[14].disabled = false;
							this.FromArrEditor[18].disabled = false;
						}

						//三季度
						if (this.currMonth >= 7 && this.currMonth <= 9) {
							this.FromArrEditor[6].disabled = true;
							this.FromArrEditor[10].disabled = true;
							this.FromArrEditor[14].disabled = false;
							this.FromArrEditor[18].disabled = false;
						}

						//四季度
						if (this.currMonth >= 10 && this.currMonth <= 12) {
							this.FromArrEditor[6].disabled = true;
							this.FromArrEditor[10].disabled = true;
							this.FromArrEditor[14].disabled = true;
							this.FromArrEditor[18].disabled = false;
						}
					} else {
						this.FromArrEditor[6].disabled = false;
						this.FromArrEditor[10].disabled = false;
						this.FromArrEditor[14].disabled = false;
						this.FromArrEditor[18].disabled = false;
					}
				}
			},
			async CustomerList(qurey, key = 1) {
				this.FromArrEditor[key].loading = true
				let {
					code,
					message,
					data
				} = await CustomerList({
					CusName: qurey,
				})
				if (code == 0) {
					this.FromArrEditor[key].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.CusCode,
							label: item.CusName
						}
						this.FromArrEditor[key].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[key].loading = false
			},
			remoteMethod(param) {
				if (param.parsign == 'AuthorizedDealer') {
					this.CustomerList(param.qurey)
				}
				if (param.parsign == 'AuthorizedTrans') {
					this.CustomerList(param.qurey, 24)
				}
			},
			// 列表
			async APPCustomerQuotaList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaList({
					ApplyCode: this.from.ApplyCode,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					Year: this.from.Year,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data

				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 第一季度月指标计算
			FirstQuarterChange(e) {
				console.log(1, e);
				e.FromArr[6].modelValue = e.FromArr[7].modelValue + e.FromArr[8].modelValue + e.FromArr[9]
					.modelValue
				e.FromArr[5].modelValue = e.FromArr[6].modelValue + e.FromArr[10].modelValue + e.FromArr[14]
					.modelValue + e
					.FromArr[18].modelValue
			},
			// 第二季度月指标计算
			SecondQuarterChange(e) {
				console.log(2, e);
				e.FromArr[10].modelValue = e.FromArr[11].modelValue + e.FromArr[12].modelValue + e.FromArr[13]
					.modelValue
				e.FromArr[5].modelValue = e.FromArr[6].modelValue + e.FromArr[10].modelValue + e.FromArr[14]
					.modelValue + e
					.FromArr[18].modelValue
			},
			// 第三季度月指标计算
			ThirdQuarterChange(e) {
				console.log(3, e);
				e.FromArr[14].modelValue = e.FromArr[15].modelValue + e.FromArr[16].modelValue + e.FromArr[17]
					.modelValue
				e.FromArr[5].modelValue = e.FromArr[6].modelValue + e.FromArr[10].modelValue + e.FromArr[14]
					.modelValue + e
					.FromArr[18].modelValue
			},
			// 第四季度月指标计算
			FourthQuarterChange(e) {
				console.log(4, e);
				e.FromArr[18].modelValue = e.FromArr[19].modelValue + e.FromArr[20].modelValue + e.FromArr[21]
					.modelValue
				e.FromArr[5].modelValue = e.FromArr[6].modelValue + e.FromArr[10].modelValue + e.FromArr[14]
					.modelValue + e
					.FromArr[18].modelValue
			},
			YearChange(e) {
				if (e.FromArr[22].options.length) {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "" &&
						e.FromArr[22].modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				} else {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				}
			},
			AuthorizedDealerChange(e) {
				if (e.FromArr[22].options.length) {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "" &&
						e.FromArr[22].modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				} else {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				}
			},
			AuthorizedTransChange(e) {
				if (e.FromArr[22].options.length) {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "" &&
						e.FromArr[22].modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				} else {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				}
			},
			invClassChange(e) {
				this.HelperLEVEL1_5({
					InvClass: e.FromArr[2].modelvalue
				})
				if (e.FromArr[22].options.length) {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "" &&
						e.FromArr[22].modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				} else {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				}
			},
			level15Change(e) {
				if (e.FromArr[22].options.length) {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "" &&
						e.FromArr[22].modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				} else {
					if (e.FromArr[0].modelvalue != "" && e.FromArr[1].modelvalue != "" && e.FromArr[2]
						.modelvalue != "") {
						this.APPCustomerQuotaGetAPPCustomerQuotaForAddNew()
						return
					}
				}
			},
			YearQuotaChange(e) {
				e.$forceUpdate()
				let indexOK = [0, 1, 2, 3, 4, 5]
				this.FromArrEditor.forEach((item, index) => {
					if (!indexOK.includes(index)) {
						this.$nextTick(() => {
							item.modelValue = undefined
						})
					}
				})

				this.QuotaDefaultRatioInfo()

			},
			// 计算分摊指标
			async QuotaDefaultRatioInfo() {
				let {
					code,
					message,
					data
				} = await QuotaDefaultRatioInfo({
					Year: this.FromArrEditor[0].modelvalue,
					InvClass: this.FromArrEditor[2].modelvalue,
				})
				if (code == 0) {

					let YearQuotaNum = this.FromArrEditor[5].modelValue

					// 第一季度
					this.FromArrEditor[7].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.JanRatio), 100);
					this.FromArrEditor[8].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.FebRatio), 100);
					this.FromArrEditor[9].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.MarRatio), 100);
					this.FromArrEditor[6].modelValue = this.FromArrEditor[7].modelValue + this
						.FromArrEditor[8]
						.modelValue + this.FromArrEditor[9].modelValue
					// 第二季度

					this.FromArrEditor[11].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.AprRatio), 100);
					this.FromArrEditor[12].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.MayRatio), 100);
					this.FromArrEditor[13].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.JunRatio), 100);
					this.FromArrEditor[10].modelValue = this.FromArrEditor[11].modelValue + this
						.FromArrEditor[12]
						.modelValue + this.FromArrEditor[13].modelValue
					// 第三季度
					this.FromArrEditor[15].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.JulRatio), 100);
					this.FromArrEditor[16].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.AugRatio), 100);
					this.FromArrEditor[17].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.SepRatio), 100);
					this.FromArrEditor[14].modelValue = this.FromArrEditor[15].modelValue + this
						.FromArrEditor[16]
						.modelValue + this.FromArrEditor[17].modelValue

					// 第四季度
					this.FromArrEditor[19].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.OctRatio), 100);
					this.FromArrEditor[20].modelValue = this.$utils.floatDiv(this.$utils.floatMul(
						YearQuotaNum, data
						.data.NovRatio), 100);

					let indexs = [7, 8, 9, 11, 12, 13, 15, 16, 17, 19, 20]
					let Sum = 0
					this.FromArrEditor.forEach((item, index) => {
						if (indexs.includes(index)) {
							Sum = this.$utils.floatAdd(Sum, item.modelValue).toFixed(0);
							console.log(Sum, item.modelValue);
						}
					})

					this.FromArrEditor[21].modelValue = Number(this.$utils.floatSub(YearQuotaNum, Sum)
						.toFixed(0));

					this.FromArrEditor[18].modelValue = this.FromArrEditor[19].modelValue + this
						.FromArrEditor[20]
						.modelValue + this.FromArrEditor[21].modelValue

					console.log('sum', this.FromArrEditor[18].modelValue, this.FromArrEditor[19]
						.modelValue, this
						.FromArrEditor[20].modelValue, this.FromArrEditor[21].modelValue);

				} else {
					this.$message.warning(message)
				}
			},
			// 新增带出往年数据					
			async APPCustomerQuotaGetAPPCustomerQuotaForAddNew() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let params = {
					InvClass: this.FromArrEditor[2].modelvalue,
					Year: this.FromArrEditor[0].modelvalue,
					LEVEL1_5: this.FromArrEditor[22].modelvalue,
				}

				if (this.FromArrEditor.length == 25) {
					params.OrgCusCode = this.FromArrEditor[24].modelvalue;
				} else {
					params.CusCode = this.FromArrEditor[1].modelvalue
				}

				let {
					code,
					message,
					data
				} = await APPCustomerQuotaGetAPPCustomerQuotaForAddNew(params)
				loading.close()
				if (code == 0) {
					this.FromArrEditor[3].checked = data.IsFirstInYear
					if (data.IsFirstInYear) {
						this.FromArrEditor[3].disabled = false;
						if (this.FromArrEditor[24]) {
							this.FromArrEditor[24].modelvalue = '';
							this.$alert(`原经销商本年度没有设置过指标，无法平移`, '提示', {
								dangerouslyUseHTMLString: true,
								showConfirmButton: false
							});
							return;
						}
					} else {
						this.FromArrEditor[3].disabled = true;
					}
					if (data.data != null) {
						this.FromArrEditor[4].checked = false // data.data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[5].modelValue = data.data.YearQuota
						this.FromArrEditor[7].modelValue = data.data.JanQuota
						this.FromArrEditor[8].modelValue = data.data.FebQuota
						this.FromArrEditor[9].modelValue = data.data.MarQuota
						this.FromArrEditor[11].modelValue = data.data.AprQuota
						this.FromArrEditor[12].modelValue = data.data.MayQuota
						this.FromArrEditor[13].modelValue = data.data.JunQuota
						this.FromArrEditor[15].modelValue = data.data.JulQuota
						this.FromArrEditor[16].modelValue = data.data.AugQuota
						this.FromArrEditor[17].modelValue = data.data.SepQuota
						this.FromArrEditor[19].modelValue = data.data.OctQuota
						this.FromArrEditor[20].modelValue = data.data.NovQuota
						this.FromArrEditor[21].modelValue = data.data.DecQuota
						this.FromArrEditor[6].modelValue = data.data.FirstQuarterQuota
						this.FromArrEditor[10].modelValue = data.data.SecondQuarterQuota
						this.FromArrEditor[14].modelValue = data.data.ThirdQuarterQuota
						this.FromArrEditor[18].modelValue = data.data.FourthQuarterQuota
					} else {
						this.FromArrEditor[5].modelValue = '';
						this.FromArrEditor[7].modelValue = '';
						this.FromArrEditor[8].modelValue = '';
						this.FromArrEditor[9].modelValue = '';
						this.FromArrEditor[11].modelValue = '';
						this.FromArrEditor[12].modelValue = '';
						this.FromArrEditor[13].modelValue = '';
						this.FromArrEditor[15].modelValue = '';
						this.FromArrEditor[16].modelValue = '';
						this.FromArrEditor[17].modelValue = '';
						this.FromArrEditor[19].modelValue = '';
						this.FromArrEditor[20].modelValue = '';
						this.FromArrEditor[21].modelValue = '';
						this.FromArrEditor[6].modelValue = '';
						this.FromArrEditor[10].modelValue = '';
						this.FromArrEditor[14].modelValue = '';
						this.FromArrEditor[18].modelValue = '';
					}
					this.OnceYearChange()
				} else {
					this.$message.warning(message)
				}
			},
			// 新增
			async APPCustomerQuotaAdd() {
				if (this.FromArrEditor.length == 25) {
					if (!this.FromArrEditor[24].modelvalue) {
						this.$message.warning('原经销商必填！');
						return;
					}
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let params = {
					CusCode: this.FromArrEditor[1].modelvalue,
					InvClass: this.FromArrEditor[2].modelvalue,
					Year: this.FromArrEditor[0].modelvalue,
					JanQuota: this.FromArrEditor[7].modelValue,
					FebQuota: this.FromArrEditor[8].modelValue,
					MarQuota: this.FromArrEditor[9].modelValue,
					AprQuota: this.FromArrEditor[11].modelValue,
					MayQuota: this.FromArrEditor[12].modelValue,
					JunQuota: this.FromArrEditor[13].modelValue,
					JulQuota: this.FromArrEditor[15].modelValue,
					AugQuota: this.FromArrEditor[16].modelValue,
					SepQuota: this.FromArrEditor[17].modelValue,
					OctQuota: this.FromArrEditor[19].modelValue,
					NovQuota: this.FromArrEditor[20].modelValue,
					DecQuota: this.FromArrEditor[21].modelValue,
					IsFirstInYear: this.FromArrEditor[3].checked ? 1 : 0,
					NeedBossApproval: 0,
					LEVEL1_5: this.FromArrEditor[22].modelvalue,
					ApplyReason: this.FromArrEditor[23].modelvalue,
				}

				if (this.FromArrEditor.length == 25) {
					params.OrgCusCode = this.FromArrEditor[24].modelvalue;
				}

				let {
					code,
					message,
					data
				} = await APPCustomerQuotaAdd(params)
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibAuthorizationsAdd = false
					this.APPCustomerQuotaList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},

			// 详情
			async APPCustomerQuotaInfo(type) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await APPCustomerQuotaInfo({
					ID: this.ID
				})
				if (code == 0) {
					if (type == 'TableBottom') {
						this.tableDataTow = []
						this.tableDataTow.push({
							row_0: `${!data.data.OrgCusCode?'现指标':'新经销商'}:` + this
								.parseMoney(data.data
									.YearQuota), // 
							row_0_trend: data.data.YearQuota_Trend,
							row_1: this.parseMoney(data.data.FirstQuarterQuota),
							row_1_trend: data.data.FirstQuarterQuota_Trend,
							row_2: this.parseMoney(data.data.SecondQuarterQuota),
							row_2_trend: data.data.SecondQuarterQuota_Trend,
							row_3: this.parseMoney(data.data.ThirdQuarterQuota),
							row_3_trend: data.data.ThirdQuarterQuota_Trend,
							row_4: this.parseMoney(data.data.FourthQuarterQuota),
							row_4_trend: data.data.FourthQuarterQuota_Trend,
						})
						this.tableDataTow.push({
							row_0: `${!data.data.OrgCusCode?'原指标':'原经销商'}:` + this
								.parseMoney(data.data
									.YearQuota_Org),
							row_1: this.parseMoney(data.data.FirstQuarterQuota_Org),
							row_2: this.parseMoney(data.data.SecondQuarterQuota_Org),
							row_3: this.parseMoney(data.data.ThirdQuarterQuota_Org),
							row_4: this.parseMoney(data.data.FourthQuarterQuota_Org),
						})
					} else if (type == 'Edit') {
						this.FromArrEditor[0].modelvalue = data.data.Year
						this.FromArrEditor[1].modelvalue = data.data.CusName
						this.FromArrEditor[2].modelvalue = data.InvClass
						this.FromArrEditor[3].checked = data.IsFirstInYear
						this.FromArrEditor[4].checked = false // data.data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[5].modelValue = data.data.YearQuota
						this.FromArrEditor[7].modelValue = data.data.JanQuota
						this.FromArrEditor[8].modelValue = data.data.FebQuota
						this.FromArrEditor[9].modelValue = data.data.MarQuota
						this.FromArrEditor[11].modelValue = data.data.AprQuota
						this.FromArrEditor[12].modelValue = data.data.MayQuota
						this.FromArrEditor[13].modelValue = data.data.JunQuota
						this.FromArrEditor[15].modelValue = data.data.JulQuota
						this.FromArrEditor[16].modelValue = data.data.AugQuota
						this.FromArrEditor[17].modelValue = data.data.SepQuota
						this.FromArrEditor[19].modelValue = data.data.OctQuota
						this.FromArrEditor[20].modelValue = data.data.NovQuota
						this.FromArrEditor[21].modelValue = data.data.DecQuota
						this.FromArrEditor[6].modelValue = data.data.FirstQuarterQuota
						this.FromArrEditor[10].modelValue = data.data.SecondQuarterQuota
						this.FromArrEditor[14].modelValue = data.data.ThirdQuarterQuota
						this.FromArrEditor[18].modelValue = data.data.FourthQuarterQuota
						this.FromArrEditor[22].modelValue = data.data.LEVEL1_5;
						this.FromArrEditor[23].modelvalue = data.data.ApplyReason;
						if (this.FromArrEditor.length == 25) {
							this.FromArrEditor[24].modelValue = data.data.OrgCusCode;
						}
						this.CusName = data.data.CusName
						this.CusCode = data.data.CusCode
						this.OnceYearChange()
						this.tableDataEditor = data.data.lstHospitalOutPuts
						this.dialogVisibAuthorizationsAdd = true
					}

				} else {
					this.$message.error(message)
				}
				loading.close()
			},
			parseMoney(num) {
				if (num && num != null) {
					num = String(num);
					var left = num.split('.')[0],
						right = num.split('.')[1];
					right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' +
						right + '0') : ''; //.00
					var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
					return (Number(num) < 0 ? "-" : "") + temp.join(',').split('').reverse()
						.join('') + right;
				} else if (num === 0) {
					return '0';
				} else {
					return "";
				}
			},
			// 修改授权申请
			async APPCustomerQuotaEdit() {
				if (this.FromArrEditor.length == 25) {
					if (!this.FromArrEditor[24].modelvalue) {
						this.$message.warning('原经销商必填！');
						return;
					}
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let params = {
					ID: this.ID,
					CusCode: this.FromArrEditor[1].modelvalue == this.CusName ? this
						.CusCode : this
						.FromArrEditor[1].modelvalue,
					InvClass: this.FromArrEditor[2].modelvalue,
					Year: this.FromArrEditor[0].modelvalue,
					JanQuota: this.FromArrEditor[7].modelValue,
					FebQuota: this.FromArrEditor[8].modelValue,
					MarQuota: this.FromArrEditor[9].modelValue,
					AprQuota: this.FromArrEditor[11].modelValue,
					MayQuota: this.FromArrEditor[12].modelValue,
					JunQuota: this.FromArrEditor[13].modelValue,
					JulQuota: this.FromArrEditor[15].modelValue,
					AugQuota: this.FromArrEditor[16].modelValue,
					SepQuota: this.FromArrEditor[17].modelValue,
					OctQuota: this.FromArrEditor[19].modelValue,
					NovQuota: this.FromArrEditor[20].modelValue,
					DecQuota: this.FromArrEditor[21].modelValue,
					IsFirstInYear: this.FromArrEditor[3].checked ? 1 : 0,
					NeedBossApproval: 0,
					LEVEL1_5: this.FromArrEditor[22].modelvalue,
					ApplyReason: this.FromArrEditor[23].modelvalue,
				}

				if (this.FromArrEditor.length == 25) {
					params.OrgCusCode = this.FromArrEditor[24].modelvalue;
				}
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaEdit(params);
				loading.close()
				if (code == 0) {
					this.dialogVisibAuthorizationsAdd = false
					this.APPCustomerQuotaList()
					this.$message.success(message)
				} else {
					this.$message.warning(message)
				}
			},
			// 删除
			async APPCustomerQuotaDelete() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaDelete({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleDel = false
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 提交
			async APPCustomerQuotaSubmit() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaSubmit({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleSubmit = false
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 撤回
			async APPCustomerQuotaRevoke() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaRevoke({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblewithdraw = false
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisiblewithdraw = false
					this.title = '撤回结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 驳回
			async APPCustomerQuotaReject() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaReject({
					IDs: IDs,
					RejectReason: this.RejectReason
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibRejectapproval = false
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibRejectapproval = false
					this.title = '驳回结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			del() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要删除的数据！(多选)")
					return
				}
				this.dialogVisibleDel = true
			},
			Submit() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要提交的数据！(多选)")
					return
				}
				this.dialogVisibleSubmit = true
			},
			cancelSubmit() {
				this.dialogVisibleSubmit = false
			},
			dialogOKSubmit() {
				this.APPCustomerQuotaSubmit()
			},
			// 导出
			async APPCustomerQuotaExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await APPCustomerQuotaExport({
					ApplyCode: this.from.ApplyCode,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					Year: this.from.Year,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (resexprot) {
					let date = new Date()
					let str =
						`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `指标申请导出${str}`,
						"xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close()
			},
			// 导出
			AppExport() {
				this.APPCustomerQuotaExport()

			},
			withdraw() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要撤回的数据！(多选)")
					return
				}
				this.dialogVisiblewithdraw = true
			},
			dialogOKwithdraw() {
				this.APPCustomerQuotaRevoke()
			},
			cancelwithdraw() {
				this.dialogVisiblewithdraw = false
			},
			// 审批通过
			async APPCustomerQuotaApprove() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.DataListOK.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaApprove({
					IDs: IDs,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleApproved = false
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibleApproved = false
					this.title = '审批结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs.fileTableSelect
						.clearSelection();
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Approved() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要审批通过的数据！(多选)")
					return
				}
				this.dialogVisibleApproved = true

			},
			cancelApproved() {
				this.dialogVisibleApproved = false
			},
			dialogOKApproved() {
				this.APPCustomerQuotaApprove()
			},
			Rejectapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要驳回的数据！(多选)")
					return
				}
				this.dialogVisibRejectapproval = true
			},
			cancelRejectapproval() {
				this.dialogVisibRejectapproval = false
			},
			dialogOKRejectapproval() {
				this.APPCustomerQuotaReject()
			},
			// 审批流程
			async APPCustomerQuotaGetHostory() {
				// const loading = this.$loading({
				//   lock: true,
				//   text: '加载中...',
				//   spinner: 'el-icon-loading',
				//   background: 'rgba(255,255,255,0.3)'
				// });
				this.loadingTableprocess = true
				let {
					code,
					message,
					data
				} = await APPCustomerQuotaGetHostory({
					ID: this.ID,
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisiblesApprovalprocess = true
					this.ApprovalProcessTableData = data
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibleApproved = false
					this.title = '结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.APPCustomerQuotaList()
					this.$refs.refTableQuota.$refs
						.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
				// loading.close()
				this.loadingTableprocess = false
			},
			Approvalprocess() {
				if (!this.ID) {
					this.$message.error("请选择需要操作的数据！")
					return
				}
				// if (this.DataListOK.length != 1) {
				// 	this.$message.error("请选择需要操作的数据！(单选)")
				// 	return
				// }
				this.APPCustomerQuotaGetHostory()
			},
			cancelApprovalprocess() {
				this.dialogVisiblesApprovalprocess = false
			},
			dialogOKApprovalprocess() {
				this.dialogVisiblesApprovalprocess = false
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArrEditor[2].options = []
					this.FromArr[3].options = []

					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						let obj2 = {
							label: item.InvClassName,
							value: item.InvClass,
						}
						this.FromArrEditor[2].options.push(obj)
						this.FromArr[3].options.push(obj2)
					})
					if (this.FromArrEditor[2].options.length) {
						this.FromArrEditor[2].modelvalue = this.FromArrEditor[2].options[0].key;
					}
					if (this.FromArrEditor[2].modelvalue) {
						this.HelperLEVEL1_5({
							InvClass: this.FromArrEditor[2].modelvalue
						})
					}
				}
			},
			// 产品分类L1.5
			async HelperLEVEL1_5(query = {}) {
				let {
					code,
					data,
					message
				} = await HelperLEVEL1_5(query)
				if (code == 0) {
					this.FromArrEditor[22].options = []
					data.forEach((item, index) => {
						if (item.key && item
							.value) {
							let obj = {
								key: item
									.key,
								value: item
									.value
							}
							this.FromArrEditor[
									22].options
								.push(obj)
						}
					})
				}
			},
			// 审批流状态下拉
			async HelperApprovalFlowStatus() {
				let {
					code,
					data,
					message
				} = await HelperApprovalFlowStatus
					({})
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item
								.Value,
							value: item
								.Text
						}
						this.FromArr[4]
							.options.push(
								obj)
					})
				} else {
					this.$message.warning(message)
				}
			},

			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},

			// 导出
			Export() {

			},
			// 删除取消
			cancelDel() {
				this.dialogVisibleDel = false
			},
			// 确认删除
			dialogOKDel() {
				this.APPCustomerQuotaDelete()
			},
			showclick() {

			},
			hide() {

			},
			select() {
				this.pageIndex = 1
				this.from.ApplyCode = this.FromArr[1].modelvalue
				this.from.CusName = this.FromArr[0].modelvalue
				this.from.Year = this.FromArr[2].modelvalue
				this.from.InvClass = this.FromArr[3].modelvalue ? this.FromArr[3].modelvalue.join(',') : ''
				this.from.Status = this.FromArr[4].modelvalue
				this.from.CreateTime1 = this.FromArr[5].StartTime
				this.from.CreateTime2 = this.FromArr[5].EndTime
				if (this.userInfo && this.userInfo.IsSaler != 1) {
					this.from.MyApproval = this.$refs.QuotaBtngroup.checkeds == true ? 1 : ""
				} else {
					this.from.MyApproval = '';
				}
				this.APPCustomerQuotaList()
			},
			reset() {
				this.$refs.QuotaBtngroup.checkeds =
					true
				this.FromArr.map((item, index) => {
					if (index == 5) {
						item.StartTime =
							'';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},

			handleSelectionChange(val) {
				this.DataListOK = val
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},

			onRowClick(val) {
				this.ID = val.ID
				this.APPCustomerQuotaInfo(
					"TableBottom")
			},
			onRowClickTow(val) {

			},
			onRowClickHP() {

			},
			onRowClickEditor() {

			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.APPCustomerQuotaList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.APPCustomerQuotaList()
			},

			cancelAuthorizationsAdd() {
				this.dialogVisibAuthorizationsAdd =
					false
			},
			dialogOKAuthorizationsAdd() {
				if (this.TitleEditor == "新增指标申请" ||
					this.TitleEditor == "新增指标平移") {
					this.APPCustomerQuotaAdd()
				}
				if (this.TitleEditor == "修改指标申请" ||
					this.TitleEditor == "修改指标平移") {
					this.APPCustomerQuotaEdit()
				}
			},
			// 月度导入
			async ImportMonthData(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportAPPCustomerQuota(formData);
					loading.close();
					if (res.code == 0) {
						this.$message.success(res.message)
						this.APPCustomerQuotaList()
					} else if (res.code == 101) {
						this.$message.warning(res.message)
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message.error(res.message)
					}
				}
			},
			async downloadMonthTemplet() {
				let {
					data,
					code,
					message
				} =
				await DownloadAPPCustomerQuota({})
				if (code == 0) {
					window.location.href = data.Value;
				} else if (code == 101) {
					this.$message.warning(message)
				} else {
					this.$message.error(message)
				}
			},
			// 年度导入
			async ImportYearData(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportYearAPPCustomerQuota(formData);
					loading.close();
					if (res.code == 0) {
						this.$message.success(res.message)
						this.APPCustomerQuotaList()
					} else if (res.code == 101) {
						this.$message.warning(res.message)
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message.error(res.message)
					}
				}
			},
			// 年度下载
			async downloadYearTemplet() {
				let {
					data,
					code,
					message
				} =
				await DownloadYearQuotaTempletQuota({})
				if (code == 0) {
					window.location.href = data.Value;
				} else if (code == 101) {
					this.$message.warning(message)
				} else {
					this.$message.error(message)
				}
			}
		},
		watch: {
			dialogVisibAuthorizationsAdd: {
				handler(newVal, OldVal) {
					console.log(newVal);
					if (!newVal) {
						FromArrEditor.forEach((item, index) => {
							let indexModelvalue = ["0", "1", "2"]
							let indexCheck = ["3"]
							let indexModelValue = ["4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14",
								"15", "16", "17", "18", "19", "20"
							]
							if (index == 5) {
								item.disabled = true
							}
							if (!indexModelvalue.includes(index)) {
								item.modelvalue = ''
							}
							if (!indexCheck.includes(index)) {
								item.checked = ''
							}
							if (!indexModelValue.includes(index)) {
								item.modelValue = undefined
							}
						})
					}
				},
				deep: true
			},
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.CusWebMenus.forEach((item, index) => {
						if (item.NodeID == 77) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, indexes) => {
										if (itemes.NodeID == to.query.MenuID) {
											let itemsss = itemes.Nodes.filter(item => item
												.NodeID == 151)[0];
											this.qus = itemsss.Buttons;
										}
									})
								}
							})
						}
					});
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.qx.approval = true
							}
						})
					}

					console.log(666666, this.qus);
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			/* margin: 1px 10px;
			width: 938px; */
			margin-top: 24px;
			height: 254px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			/* margin: 32px 10px; */
			margin-top: 24px;
			padding: 10px;
			/* width: 920px; */
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
	}

	.TableBottom {
		border: 1px solid red;
	}

	.line {
		width: 960px;
		height: 1px;
		background: #e5e7ea;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 20px;
	}

	.TableTitle {
		margin-left: 10px;
		margin-top: 5px;
		margin-bottom: 5px;
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid rgb(230 230 230);
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		color: rgb(231 29 67);
		background-color: rgb(252 232 236);
	}

	/deep/.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: #e71d4399;
		color: #ffffff;
	}
</style>